/** @graphql cc **/
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const ContentOperationsQuery: GraphQLTaggedNode = graphql`
	query ContentOperationsQuery($contentId: ID!, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				...ContentOperationsFragment @relay(mask: false)
			}
		}
	}
`;
